import React from 'react';
import * as _ from 'lodash';
import $ from 'jquery';
import {Box} from 'reactjs-admin-lte';
import {
  Button, Modal,
  ControlLabel, FormControl, FormGroup,
} from 'react-bootstrap';
// import {JsonEditor} from 'react-json-edit';
import API from './../../utils/api';
import './AdminConfig.css';
import FontAwesome from 'react-fontawesome';
import ReactJson from 'react-json-view';
import ConfirmPopup from '../../component/element/ConfirmPopup';
import AdminConfigHistory from './AdminConfigHistory';
import {JsonEditor as Editor} from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

const NotificationSystem = require('react-notification-system');

export default class AdminConfig extends React.Component {

  static defaultProps = {
    saving: false,
    config_options_url: '/admin/config_options',
    config_history_url: '/admin/config_options_rev',
    data: {},
  };

  realtime = null;

  constructor(props) {
    super(props);
    this.state = {
      saving: props.saving,
      api_url: props.api_url,
      query: '',
      data: props.data,
      base_data: props.data,
      editItem: {},
      editModal: false,
      historyItem: {},
      historyData: [],
      historyModal: false,
      sendJsonText: '',
      loadingConfig: false,
      editConfirm: false,
      historyConfirm: false,
    };

  }

  componentWillMount() {
    this.loadConfigData();
  }

  loadConfigData() {
    this.setState({loadingConfig: true});
    return API.get(this.props.config_options_url).then((response) => {
      if (response && response.data) {
        const data = _.map(
            _.sortBy([...response.data.data], 'option_name'),
            item => ({
              ...item,
              collapsed: true,
            }),
        );
        this.setState({
          data,
          loadingConfig: false,
          base_data: _.cloneDeep(data),
        });
      }
    }).catch(function(error) {
      console.log(error);
      window.alert(error);
    });
  }

  postConfig(data) {
    return API.post(this.props.config_options_url, data).
        then((response) => {
          console.log(response.data);
          this.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกข้อมูลเรียบร้อยแล้ว',
            level: 'success',
            position: 'tc',
          });
        }).
        catch((error) => {
          console.log(error);
          this.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'error',
            level: 'error',
            position: 'tc',
          });
        });
  }

  difference(object, base) {
    return _.transform(object, (result, value, key) => {
      if (!_.isEqual(value, base[key])) {
        result[key] = _.isObject(value) && _.isObject(base[key])
            ? this.difference(value, base[key]) : value;
      }
    });
  }

  saveEditModal = () => {
    this.postConfig(this.state.editItem).
        then(() => {
          // this.closeModal();
          this.loadConfigData();
        });
  };

  closeModal = () => {
    this.setState({
      editItem: {},
      editModal: false,
      editConfirm: false,
      historyItem: {},
      historyData: [],
      historyEditItem: {},
      historyModal: false,
      historyConfirm: false,
    });
  };

  configToggle = (toggle_index) => {
    return () => {
      let {data} = this.state;
      this.setState({
        data: _.map(data, (item, index) => {
          if (index !== toggle_index) {
            return item;
          }

          return {
            ...item,
            collapsed: !item.collapsed,
          };
        }),
      });
    };
  };

  handleChangeJSON = option_value => {
    this.setState(state => {
      let editItem = {
        ...this.state.editItem,
        option_value,
      };
      return {editItem};
    });
  };

  render() {
    const {state, props} = this;
    const {
      data, query, editItem, editModal,
      loadingConfig,
      historyModal, historyItem,
    } = state;

    const filtered_data = _.isEmpty(query) ? data : _.filter(data, item => {
      const search_regex = new RegExp(query);
      return search_regex.test(JSON.stringify(item.option_value)) ||
             search_regex.test(JSON.stringify(item.option_name));
    });
    return (
        <div className="admin-config-content" id={'admin-config-page'}>
          <Box loading={loadingConfig}>
            <Box.Body>
              <FormGroup>
                <ControlLabel>Search by Option Name/Option Value</ControlLabel>
              <FormControl
                  type="text"
                  value={this.state.query}
                  onChange={(e) => this.setState({query: e.target.value})}
                  placeholder={this.state.query} />
            </FormGroup>

              <div className={'table-responsive'}>
                <table
                    className={'table table-bordered table-hover table-striped'}>
                  <thead>
                  <tr className={'bg-primary'}>
                    <th>Option Name</th>
                    <th>Data Type</th>
                    <th>Option Value</th>
                    <th style={{minWidth: '110px'}}>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  {_.map(filtered_data, (item, index) => {
                    return (
                        <tr key={index}>
                          <td>{item.option_name}</td>
                          <td>{item.data_type}</td>
                          <td>
                            {item.data_type === 'JSON' ?
                                <ReactJson src={item.option_value}
                                           collapsed={item.collapsed} /> :
                                <span>{item.option_value}</span>
                            }
                          </td>
                          <td>
                            <Button bsStyle={'primary'}
                                    onClick={this.onEditModal(item)}>
                              <FontAwesome name={'edit'} />
                            </Button>
                            {' '}
                            <Button bsStyle={'info'}
                                    onClick={this.onHistoryModal(item)}>
                              <FontAwesome name={'history'} />
                            </Button>
                            {' '}
                            {item.data_type === 'JSON' ?
                                <Button bsStyle={'default'}
                                        onClick={this.configToggle(index)}>
                                  <FontAwesome
                                      name={item.collapsed
                                          ? 'eye'
                                          : 'eye-slash'} />
                                </Button> : null}
                          </td>
                        </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
            </Box.Body>
          </Box>

          {this.renderEditModal()}
          {/*{this.renderHistoryModal()}*/}
          <AdminConfigHistory
              notification={this.refs.notificationSystem}
              modal={historyModal}
              item={historyItem}
              onHide={() => {
                return this.setState({
                  historyModal: false,
                  historyItem: {},
                });
              }}
              onChange={() => this.loadConfigData()}
          />
          <NotificationSystem ref="notificationSystem" />
        </div>
    );
  }

  onEditModal = (item) => {
    return () => {
      this.setState({
        editItem: item,
        editModal: true,
      });
    };
  };

  onOptionUpdate = (e) => {
    this.setState(state => {
      let editItem = {
        ...this.state.editItem,
        option_value: e.updated_src,
      };
      return {editItem};
    });
  };

  renderEditModal() {
    const {state} = this;
    const {editModal, editItem, editConfirm} = state;

    return (
        <Modal show={editModal} enforceFocus={false}
               dialogClassName={'modal-lg'}
               onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>{`แก้ไขข้อมูล : ${editItem.option_name}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body  style={{maxHeight: '500px', overflow: 'auto'}}>
            {editItem.data_type === 'JSON' ?
                <Editor value={editItem.option_value}
                        onChange={this.handleChangeJSON} />
                : <input type={'text'}
                         value={editItem.option_value}
                         onChange={(e) => {
                           this.setState({
                             editItem: {
                               ...this.state.editItem,
                               option_value: e.target.value,
                             },
                           });
                         }}
                         className={'form-control'} />
            }
          </Modal.Body>
          <Modal.Footer>
            <div className={'text-right'}>
              <Button bsStyle={'primary'}
                      onClick={() => {
                        this.setState({editConfirm: true});
                      }}>
                <FontAwesome name={'save'} /> บันทึก
              </Button>
              <Button bsStyle={'default'}
                      onClick={this.closeModal}>
                <FontAwesome name={'close'} /> ปิด
              </Button>
            </div>

            <ConfirmPopup show={editConfirm} title="ยืนยัน"
                          confirmTitle="ยืนยัน" cancelTitle="ยกเลิก"
                          message="ยืนยันการแก้ไขข้อมูล"
                          onConfirm={this.saveEditModal}
                          onHide={() => {
                            this.setState({editConfirm: false});
                          }}
            />
          </Modal.Footer>
        </Modal>
    );
  }

  onHistoryModal = (item) => {
    return () => {
      this.setState({
        historyItem: item,
        historyModal: true,
      });
    };
  };

}


// WEBPACK FOOTER //
// ./src/view/debug/AdminConfig.js